import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { trackPromise } from "react-promise-tracker";
import { toast } from "react-toastify";
import suppliesApi from "../../constants/suppliesApi";

const AddModal = ({ vehicle }) => {
  const [open, setOpen] = useState(false);
  const [odometer, setOdometer] = useState([]);
  const [odometers, setOdometers] = useState([]);
  const [code, setCode] = useState("");

  useEffect(() => {
    if (open) {
      getOdometerByVehicle();
    }
  }, [open]);

  const getOdometers = () => {
    trackPromise(
      suppliesApi
        .getOdometersByCustomer(localStorage.getItem("GlobalCustomerId"))
        .then((res) => {
          setOdometers(res);
        })
        .catch((err) => {
          toast.error(err.response.data.detail);
        })
    );
  };

  const getOdometerByVehicle = () => {
    trackPromise(
      suppliesApi
        .getOdometersByVehicle(
          localStorage.getItem("GlobalCustomerId"),
          vehicle.id
        )
        .then((res) => {
          if (res.length === 0) {
            getOdometers();
          }
          setOdometer(res);
        })
        .catch((err) => {
          toast.error(err.response.data.detail);
        })
    );
  };

  const addOdometer = () => {
    const body = {
      odometer: code,
      vehicle: vehicle.id,
      customer: localStorage.getItem("GlobalCustomerId"),
    };

    trackPromise(
      suppliesApi
        .addOdomoterToVehicle(body)
        .then((res) => {
          setOpen(false);
          setOdometer([]);
          setOdometers([]);
          setCode("");
          toast.success("Odometro asociado");
        })
        .catch((err) => {
          toast.error(err.response.data.detail);
        })
    );
  };

  const modal = () => {
    return (
      <Modal
        show={open}
        dialogClassName="modal-sm-providers"
        onHide={() => setOpen(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {odometer.length ? "Odometro" : "Agregar Odometro"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {odometer.length ? (
            <div>
              <div className="text-center v-scroll mt-2">
                <table className="table table-striped table-bordered table-sm mb-0">
                  <thead>
                    <tr>
                      <th scope="col">Codigo</th>
                      <th scope="col">Kilometraje Actual</th>
                      <th scope="col">Vehiculo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr key={odometer[0].id}>
                      <td className="p-2">{odometer[0].code}</td>
                      <td className="p-2">{odometer[0].current_km}</td>
                      <td className="p-2">{odometer[0].vehicle}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div>
              <div className="form-group">
                <label>Odometros</label>
                <select
                  className="form-control"
                  onChange={(e) => setCode(e.target.value)}
                >
                  <option value="">Seleccione</option>
                  {odometers &&
                    odometers.map((odometer) => (
                      <option key={odometer.id} value={odometer.id}>
                        {odometer.code}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {odometer && (
            <button
              className="btn btn-primary"
              disabled={code.length ? false : true}
              onClick={() => addOdometer()}
            >
              Agregar
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <button className="btn btn-primary" onClick={() => setOpen(true)}>
        Odometro
      </button>
      {open && modal()}
    </>
  );
};

export default AddModal;
